module.exports = __webpack_public_path__ + "static/media/StarLeft.9e2791d9.svg";